var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('q-pull-to-refresh',{staticClass:"pullRefresh",on:{"refresh":_vm.refresh}},[_c('DataCard',{attrs:{"data":_vm.filteredLinks,"fields":_vm.fields,"fieldEventName":"name"},on:{"cardClick":_vm.cardClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }